import { render, staticRenderFns } from "./questionOption.vue?vue&type=template&id=2d2badcf&scoped=true"
import script from "./questionOption.vue?vue&type=script&lang=js"
export * from "./questionOption.vue?vue&type=script&lang=js"
import style0 from "./questionOption.vue?vue&type=style&index=0&id=2d2badcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2badcf",
  null
  
)

export default component.exports